import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import './Search.css';


class Search extends Component {

    constructor(props) {
        super(props);
        this.state = {
            criteres: ""
        };
    }

    runSearch = () => {
        this.props.action(this.state.criteres);
    }

    handleChange = event => {
        this.setState({
            criteres: event.target.value,
        });
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.runSearch();
        }
    }

    handleClickClearSearch = () => {
        this.setState({
            criteres: "",
        });
        this.props.action("");
    } 

    render() {
        return (
            <div className="search">
                <Paper>
                    <TextField
                        label={this.props.label}
                        value={this.state.criteres}
                        onChange={this.handleChange}
                        onKeyPress={this.handleKeyPress}
                        className="searchTextField"
                        type="search"
                    />
                    <Button onClick={this.runSearch}
                        className="searchButton">
                        <SearchIcon />
                    </Button>
                </Paper>
            </div>
        );
    }
}

Search.propTypes = {
    action: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired
};

export default Search;


// WEBPACK FOOTER //
// ./src/components/content/search/Search.js